export enum OrderActionTypes {
  SET_ORDER_DATA = "SET_ORDER_DATA",
}
